'use client'

import './admin.css'
import PasswordGate from '@/components/admin/PasswordGate'
import SandboxBanner from '@/components/admin/SandboxBanner'
import AdminShell from '@/components/admin/AdminShell'
import UndoToastProvider from '@/components/admin/UndoToastProvider'
import { ToastProvider } from '@/components/shared/Toast'

export default function AdminLayout({ children }) {
  return (
    <ToastProvider>
      <PasswordGate>
        <div className="admin-root">
          <SandboxBanner />
          <UndoToastProvider>
            <AdminShell>{children}</AdminShell>
          </UndoToastProvider>
        </div>
      </PasswordGate>
    </ToastProvider>
  )
}
